import { FormInput, Grid } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Naam aangever"
      description={`Typ hieronder uw Voornaam en Naam (indien correct druk op "volgende")`}
    >
      <Grid container spacing={4}>
        <FormInput
          name="voornaam"
          label="Voornaam"
          placeholder="Vul je voornaam in"
          xs={12}
          sm={6}
          required
        />
        <FormInput
          name="naam"
          label="Naam"
          placeholder="Vul je achternaam in"
          xs={12}
          sm={6}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
